export default [
  {
    path: '/real-estate-developments-settings/personalizations',
    name: 'PersonalizationsList',
    component: () => import('pages/real-estate-developments-settings/personalizations/list/PersonalizationsList.vue')
  },
  {
    path: '/real-estate-developments-settings/personalizations/new',
    name: 'PersonalizationsCreate',
    component: () => import('pages/real-estate-developments-settings/personalizations/PersonalizationsForm.vue')
  },
  {
    path: '/real-estate-developments-settings/personalizations/:id/edit',
    name: 'PersonalizationsEdit',
    component: () => import('pages/real-estate-developments-settings/personalizations/PersonalizationsForm.vue')
  }
]
